import { createSlice } from '@reduxjs/toolkit';

import { localeToLanguage } from './utils';

const initialState = {
    currency: '',
    locale: '',
    supportedCurrencies: [],
    supportedLocales: [],
};

const i18nSlice = createSlice({
    initialState,
    name: 'i18n',
    reducers: {
        setCurrency: (state, action) => {
            state.currency = action.payload;
        },
        setLocale: (state, action) => {
            state.locale = action.payload;
        },
        setLocaleAndCurrency: (state, action) => {
            const { currency, locale } = action.payload;

            state.currency = currency;
            state.locale = locale;
        },
        setSupportedCurrencies: (state, action) => {
            state.supportedCurrencies = action.payload;
        },
        setSupportedLocales: (state, action) => {
            const supportedLocales = action.payload;
            let { locale } = state;

            // build locale object
            if (locale) {
                const newLocale = supportedLocales.find(
                    (supportedLocale) => supportedLocale === locale
                );

                state.locale = newLocale || locale;
            }

            state.supportedLocales = supportedLocales;
        },
    },
    selectors: {
        languageSelector: (state) => localeToLanguage(state.locale),
        selectCurrency: (state) => state?.currency,
        selectLocale: (state) => state?.locale,
    },
});

const { actions, reducer, selectors } = i18nSlice;

export const {
    setCurrency,
    setLocale,
    setLocaleAndCurrency,
    setSupportedCurrencies,
    setSupportedLocales,
} = actions;

export const {
    languageSelector,
    selectCurrency,
    selectLocale,
} = selectors;

export { i18nSlice };
export default reducer;
